import type { FC, HTMLAttributes, ReactNode } from "react";
import { cn } from "../utilities/cn";
import {
  textBody,
  textHeading,
  textHeadingLg,
  textMuted,
  textSecondary,
} from "../utilities/styles";
import {
  textPageTitle,
  textPageDescription,
  textSectionTitle,
  textSectionTitleLg,
  textDetailTitle,
} from "../utilities/layout";

export type TextVariant =
  | "body"
  | "heading"
  | "heading-lg"
  | "muted"
  | "secondary"
  | "page-title"
  | "page-description"
  | "section-title"
  | "section-title-lg"
  | "detail-title";

export interface TextProps extends HTMLAttributes<HTMLElement> {
  as?: "p" | "span" | "h1" | "h2" | "h3" | "h4" | "div";
  variant?: TextVariant;
  children: ReactNode;
}

const variantClasses: Record<TextVariant, string> = {
  body: textBody,
  heading: textHeading,
  "heading-lg": textHeadingLg,
  muted: textMuted,
  secondary: textSecondary,
  "page-title": textPageTitle,
  "page-description": textPageDescription,
  "section-title": textSectionTitle,
  "section-title-lg": textSectionTitleLg,
  "detail-title": textDetailTitle,
};

/**
 * Typography primitive consuming semantic text tokens.
 */
export const Text: FC<TextProps> = ({
  as: Tag = "p",
  variant = "body",
  className,
  children,
  ...rest
}) => (
  <Tag className={cn(variantClasses[variant], className)} {...rest}>
    {children}
  </Tag>
);
